const getTextFromHTML = htmlString => {
  const div = document.createElement('div')
  div.innerHTML = htmlString
  return div.textContent
}

export default getTextFromHTML
